<p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
<button
  type="button"
  pButton
  icon="pi pi-bars"
  (click)="menu.toggle($event)"
></button>
<app-loader></app-loader>
<p-toast></p-toast>
<app-intro
  [showOverlay]="showIntroOverlay"
  (overlayClosedEvt)="closeIntro()"
></app-intro>
<router-outlet></router-outlet>
